import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

function FirmaEkle() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sube = queryParams.get('sube') || 'Bilinmeyen Şube';
  const [firmaIsmi, setFirmaIsmi] = useState('');
  const [yetkili, setYetkili] = useState('');
  const [vergiNo, setVergiNo] = useState('');
  const [vergiDairesi, setVergiDairesi] = useState('');
  const [firmaAdresi, setFirmaAdresi] = useState('');
  const [firmaIletisimNo, setFirmaIletisimNo] = useState('+90 ');
  const [yetkiliIletisimNo, setYetkiliIletisimNo] = useState('+90 ');
  const [bilgiler, setBilgiler] = useState('');
  const [hata, setHata] = useState('');
  const [basari, setBasari] = useState('');
  const [errors, setErrors] = useState({});

  // Firma ismini Firebase belge ID'si için uygun formata dönüştürme
  const normalizeString = (str) => {
    return str
      ? str
          .trim()
          .toLowerCase()
          .replace(/\s+/g, '-')
          .replace(/[^a-z0-9-]/g, '')
      : '';
  };

  const toUpperTr = (value) => (value || '').toLocaleUpperCase('tr-TR');

  const formatPhoneNumber = (value) => {
    const raw = (value || '').replace(/[^\d]/g, '');
    let local = raw;
    if (local.startsWith('90')) local = local.slice(2);
    local = local.slice(0, 10);

    const p1 = local.slice(0, 3);
    const p2 = local.slice(3, 6);
    const p3 = local.slice(6, 8);
    const p4 = local.slice(8, 10);

    let formatted = '+90';
    if (p1) formatted += ` ${p1}`;
    if (p2) formatted += ` ${p2}`;
    if (p3) formatted += ` ${p3}`;
    if (p4) formatted += ` ${p4}`;
    if (!p1) formatted += ' ';
    return formatted;
  };

  const validateForm = async () => {
    const newErrors = {};
    if (!firmaIsmi) newErrors.firmaIsmi = 'Firma ismi zorunlu';
    if (vergiNo && !/^\d{10,}$/.test(vergiNo)) newErrors.vergiNo = 'Geçerli bir vergi numarası girin';
    if (firmaIletisimNo && firmaIletisimNo.trim() !== '+90' && !/^\+90\s\d{3}\s\d{3}\s\d{2}\s\d{2}$/.test(firmaIletisimNo)) {
      newErrors.firmaIletisimNo = 'Telefon formatı +90 5xx xxx xx xx olmalı';
    }
    if (yetkiliIletisimNo && yetkiliIletisimNo.trim() !== '+90' && !/^\+90\s\d{3}\s\d{3}\s\d{2}\s\d{2}$/.test(yetkiliIletisimNo)) {
      newErrors.yetkiliIletisimNo = 'Telefon formatı +90 5xx xxx xx xx olmalı';
    }

    // Firma isminin benzersizliğini kontrol et
    const normalizedFirmaIsmi = normalizeString(firmaIsmi);
    if (normalizedFirmaIsmi) {
      const firmaRef = doc(db, 'subeler', sube, 'firmalar', normalizedFirmaIsmi);
      const firmaSnap = await getDoc(firmaRef);
      if (firmaSnap.exists()) {
        newErrors.firmaIsmi = 'Bu firma ismi zaten kayıtlı';
      }
    } else {
      newErrors.firmaIsmi = 'Geçerli bir firma ismi girin';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setHata('');
    setBasari('');
    if (!(await validateForm())) {
      setHata('Lütfen tüm zorunlu alanları doğru doldurun.');
      return;
    }

    try {
      const normalizedFirmaIsmi = normalizeString(firmaIsmi);
      const firmaRef = doc(db, 'subeler', sube, 'firmalar', normalizedFirmaIsmi);
      await setDoc(firmaRef, {
        firmaIsmi,
        yetkili: yetkili || null,
        vergiNo: vergiNo || null,
        vergiDairesi: vergiDairesi || null,
        firmaAdresi: firmaAdresi || null,
        firmaIletisimNo: firmaIletisimNo || null,
        yetkiliIletisimNo: yetkiliIletisimNo || null,
        bilgiler: bilgiler || null,
        timestamp: new Date(),
        sube
      });
      setBasari('Firma başarıyla eklendi.');
      setHata('');
      setFirmaIsmi('');
      setYetkili('');
      setVergiNo('');
      setVergiDairesi('');
      setFirmaAdresi('');
      setFirmaIletisimNo('+90 ');
      setYetkiliIletisimNo('+90 ');
      setBilgiler('');
      setErrors({});
    } catch (err) {
      setHata(`Firma eklenemedi: ${err.message}`);
      setBasari('');
      console.error('Firestore Hatası:', err);
    }
  };

  const labelStyle = {
    fontSize: '16px',
    color: '#1f2937',
    width: '190px',
    fontWeight: 700
  };

  const inputBaseStyle = {
    width: '100%',
    height: '42px',
    padding: '10px 12px',
    fontSize: '15px',
    borderRadius: '8px',
    border: '1px solid #cfd8e3',
    outline: 'none',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    transition: 'border-color .2s, box-shadow .2s'
  };

  return (
    <div
      className="firma-ekle-page"
      style={{
      background: 'linear-gradient(180deg, #f6f9ff 0%, #eef3fb 100%)',
      borderRadius: '14px',
      padding: '18px',
      boxShadow: '0 8px 20px rgba(15, 23, 42, 0.08)',
      border: '1px solid #d7e0ec',
      width: '900px',
      minHeight: '640px',
      display: 'flex',
      flexDirection: 'column',
      margin: '0 auto',
      overflowY: 'auto',
      fontFamily: "'Helvetica Neue', sans-serif",
      position: 'relative'
    }}
    >
      <div className="firma-ekle-header" style={{ borderBottom: '1px solid #e2e8f0', marginBottom: '14px', paddingBottom: '10px' }}>
        <h2 className="firma-ekle-title" style={{ margin: 0, fontSize: '28px', color: '#102a43', letterSpacing: '0.2px' }}>Firma Ekle</h2>
        <p className="firma-ekle-subtitle" style={{ margin: '4px 0 0', color: '#64748b', fontSize: '14px' }}>Firma bilgilerini kurumsal kayıt standardına göre ekleyin.</p>
      </div>

      <form className="firma-ekle-form" onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '10px', background: '#ffffff', border: '1px solid #dde5f0', borderRadius: '12px', padding: '14px' }}>
        <div className="firma-ekle-row" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <label className="firma-ekle-label" style={labelStyle}>Firma İsmi *</label>
          <div className="firma-ekle-field" style={{ flex: 1, maxWidth: '560px' }}>
            <input
              type="text"
              value={firmaIsmi}
              onChange={(e) => setFirmaIsmi(toUpperTr(e.target.value))}
              placeholder="Firma İsmi"
              style={{ ...inputBaseStyle, border: errors.firmaIsmi ? '1px solid #e63946' : inputBaseStyle.border }}
              onFocus={(e) => { e.target.style.borderColor = '#b47a2a'; e.target.style.boxShadow = '0 0 0 3px rgba(180, 122, 42, 0.15)'; }}
              onBlur={(e) => { e.target.style.borderColor = errors.firmaIsmi ? '#e63946' : '#cfd8e3'; e.target.style.boxShadow = 'none'; }}
            />
            {errors.firmaIsmi && <p style={{ color: '#e63946', fontSize: '13px', marginTop: '4px' }}>{errors.firmaIsmi}</p>}
          </div>
        </div>

        <div className="firma-ekle-row" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <label className="firma-ekle-label" style={labelStyle}>Firma Yetkilisi</label>
          <div className="firma-ekle-field" style={{ flex: 1, maxWidth: '560px' }}>
            <input
              type="text"
              value={yetkili}
              onChange={(e) => setYetkili(toUpperTr(e.target.value))}
              placeholder="Firma Yetkilisi"
              style={inputBaseStyle}
              onFocus={(e) => { e.target.style.borderColor = '#b47a2a'; e.target.style.boxShadow = '0 0 0 3px rgba(180, 122, 42, 0.15)'; }}
              onBlur={(e) => { e.target.style.borderColor = '#cfd8e3'; e.target.style.boxShadow = 'none'; }}
            />
          </div>
        </div>

        <div className="firma-ekle-row" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <label className="firma-ekle-label" style={labelStyle}>Firma Vergi No</label>
          <div className="firma-ekle-field" style={{ flex: 1, maxWidth: '560px' }}>
            <input
              type="text"
              value={vergiNo}
              onChange={(e) => setVergiNo((e.target.value || '').replace(/\D/g, '').slice(0, 11))}
              placeholder="Firma Vergi No"
              style={{ ...inputBaseStyle, border: errors.vergiNo ? '1px solid #e63946' : inputBaseStyle.border }}
              onFocus={(e) => { e.target.style.borderColor = '#b47a2a'; e.target.style.boxShadow = '0 0 0 3px rgba(180, 122, 42, 0.15)'; }}
              onBlur={(e) => { e.target.style.borderColor = errors.vergiNo ? '#e63946' : '#cfd8e3'; e.target.style.boxShadow = 'none'; }}
            />
            {errors.vergiNo && <p style={{ color: '#e63946', fontSize: '13px', marginTop: '4px' }}>{errors.vergiNo}</p>}
          </div>
        </div>

        <div className="firma-ekle-row" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <label className="firma-ekle-label" style={labelStyle}>Firma Vergi Dairesi</label>
          <div className="firma-ekle-field" style={{ flex: 1, maxWidth: '560px' }}>
            <input
              type="text"
              value={vergiDairesi}
              onChange={(e) => setVergiDairesi(toUpperTr(e.target.value))}
              placeholder="Firma Vergi Dairesi"
              style={inputBaseStyle}
              onFocus={(e) => { e.target.style.borderColor = '#b47a2a'; e.target.style.boxShadow = '0 0 0 3px rgba(180, 122, 42, 0.15)'; }}
              onBlur={(e) => { e.target.style.borderColor = '#cfd8e3'; e.target.style.boxShadow = 'none'; }}
            />
          </div>
        </div>

        <div className="firma-ekle-row" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <label className="firma-ekle-label" style={labelStyle}>Firma Adresi</label>
          <div className="firma-ekle-field" style={{ flex: 1, maxWidth: '560px' }}>
            <input
              type="text"
              value={firmaAdresi}
              onChange={(e) => setFirmaAdresi(toUpperTr(e.target.value))}
              placeholder="Firma Adresi"
              style={inputBaseStyle}
              onFocus={(e) => { e.target.style.borderColor = '#b47a2a'; e.target.style.boxShadow = '0 0 0 3px rgba(180, 122, 42, 0.15)'; }}
              onBlur={(e) => { e.target.style.borderColor = '#cfd8e3'; e.target.style.boxShadow = 'none'; }}
            />
          </div>
        </div>

        <div className="firma-ekle-row" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <label className="firma-ekle-label" style={labelStyle}>Firma İletişim No</label>
          <div className="firma-ekle-field" style={{ flex: 1, maxWidth: '560px' }}>
            <input
              type="text"
              value={firmaIletisimNo}
              onChange={(e) => setFirmaIletisimNo(formatPhoneNumber(e.target.value))}
              placeholder="+90 5xx xxx xx xx"
              style={{ ...inputBaseStyle, border: errors.firmaIletisimNo ? '1px solid #e63946' : inputBaseStyle.border }}
              onFocus={(e) => { e.target.style.borderColor = '#b47a2a'; e.target.style.boxShadow = '0 0 0 3px rgba(180, 122, 42, 0.15)'; }}
              onBlur={(e) => { e.target.style.borderColor = errors.firmaIletisimNo ? '#e63946' : '#cfd8e3'; e.target.style.boxShadow = 'none'; }}
            />
            {errors.firmaIletisimNo && <p style={{ color: '#e63946', fontSize: '13px', marginTop: '4px' }}>{errors.firmaIletisimNo}</p>}
          </div>
        </div>

        <div className="firma-ekle-row" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <label className="firma-ekle-label" style={labelStyle}>Yetkili İletişim No</label>
          <div className="firma-ekle-field" style={{ flex: 1, maxWidth: '560px' }}>
            <input
              type="text"
              value={yetkiliIletisimNo}
              onChange={(e) => setYetkiliIletisimNo(formatPhoneNumber(e.target.value))}
              placeholder="+90 5xx xxx xx xx"
              style={{ ...inputBaseStyle, border: errors.yetkiliIletisimNo ? '1px solid #e63946' : inputBaseStyle.border }}
              onFocus={(e) => { e.target.style.borderColor = '#b47a2a'; e.target.style.boxShadow = '0 0 0 3px rgba(180, 122, 42, 0.15)'; }}
              onBlur={(e) => { e.target.style.borderColor = errors.yetkiliIletisimNo ? '#e63946' : '#cfd8e3'; e.target.style.boxShadow = 'none'; }}
            />
            {errors.yetkiliIletisimNo && <p style={{ color: '#e63946', fontSize: '13px', marginTop: '4px' }}>{errors.yetkiliIletisimNo}</p>}
          </div>
        </div>

        <div className="firma-ekle-row firma-ekle-row-textarea" style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
          <label className="firma-ekle-label" style={labelStyle}>Firma Bilgileri</label>
          <div className="firma-ekle-field" style={{ flex: 1, maxWidth: '560px' }}>
            <textarea
              value={bilgiler}
              onChange={(e) => setBilgiler(toUpperTr(e.target.value))}
              placeholder="Firma Bilgileri"
              rows="3"
              style={{ ...inputBaseStyle, minHeight: '78px', resize: 'none', height: 'auto' }}
              onFocus={(e) => { e.target.style.borderColor = '#b47a2a'; e.target.style.boxShadow = '0 0 0 3px rgba(180, 122, 42, 0.15)'; }}
              onBlur={(e) => { e.target.style.borderColor = '#cfd8e3'; e.target.style.boxShadow = 'none'; }}
            />
          </div>
        </div>

        <button
          type="submit"
          className="firma-ekle-submit"
          style={{
            padding: '11px',
            fontSize: '17px',
            fontWeight: 700,
            borderRadius: '8px',
            border: '1px solid #955d18',
            background: 'linear-gradient(135deg, #c98a30 0%, #a8671d 100%)',
            color: '#fff',
            cursor: 'pointer',
            transition: 'all 0.2s',
            marginTop: '8px',
            letterSpacing: '0.3px'
          }}
          onMouseEnter={(e) => {
            if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
              e.target.style.filter = 'brightness(1.05)';
            }
          }}
          onMouseLeave={(e) => {
            if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
              e.target.style.filter = 'brightness(1)';
            }
          }}
        >
          Firma Ekle
        </button>

        {hata && (
          <p style={{
            fontSize: '14px',
            color: '#b91c1c',
            backgroundColor: '#fee2e2',
            border: '1px solid #fecaca',
            padding: '9px',
            borderRadius: '8px',
            marginTop: '4px',
            textAlign: 'center'
          }}>
            {hata}
          </p>
        )}
        {basari && (
          <p style={{
            fontSize: '14px',
            color: '#166534',
            backgroundColor: '#dcfce7',
            border: '1px solid #bbf7d0',
            padding: '9px',
            borderRadius: '8px',
            marginTop: '4px',
            textAlign: 'center'
          }}>
            {basari}
          </p>
        )}
      </form>

      <style>{`
        /* --- MOBİL: Firma Ekle (masaüstü inline stillere dokunulmaz) --- */
        @media (max-width: 480px) {
          .firma-ekle-page {
            width: 100% !important;
            max-width: 100% !important;
            min-height: auto !important;
            padding: 12px !important;
            border-radius: 12px !important;
            box-sizing: border-box !important;
            overflow-x: hidden !important;
          }

          .firma-ekle-title {
            font-size: 22px !important;
          }

          .firma-ekle-subtitle {
            font-size: 13px !important;
            line-height: 1.45 !important;
          }

          .firma-ekle-form {
            padding: 12px !important;
            gap: 12px !important;
          }

          .firma-ekle-row {
            flex-direction: column !important;
            align-items: stretch !important;
            gap: 6px !important;
          }

          .firma-ekle-row-textarea {
            align-items: stretch !important;
          }

          .firma-ekle-label {
            width: 100% !important;
            font-size: 14px !important;
          }

          .firma-ekle-field {
            max-width: none !important;
            width: 100% !important;
          }

          .firma-ekle-page input,
          .firma-ekle-page textarea {
            font-size: 16px !important;
          }

          .firma-ekle-submit {
            width: auto !important;
            min-width: 200px !important;
            justify-self: center !important;
            align-self: center !important;
            font-size: 16px !important;
            padding: 12px 22px !important;
            touch-action: manipulation;
            -webkit-tap-highlight-color: transparent;
          }
        }
      `}</style>
    </div>
  );
}

export default FirmaEkle;